import { render } from "./mapControlsArchive.vue?vue&type=template&id=50ae956b&scoped=true"
import script from "./mapControlsArchive.vue?vue&type=script&lang=js"
export * from "./mapControlsArchive.vue?vue&type=script&lang=js"

import "./mapControlsArchive.vue?vue&type=style&index=0&id=50ae956b&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ae956b"]])

export default __exports__